import React from 'react'
import { Link } from 'react-router-dom'

const SectionOne = () => {
    return (
            <div className='container'>
                <h6 className='mb-6 text-sm text-white header-font'>CORPORATE</h6 >
                <div className="text-sm text-gray-500 ">
                    <p className='mt-3 cursor-pointer'><Link to='About-us'>About Us</Link></p>
                    <p className='mt-3 cursor-pointer'>Blog</p>
                    <p className='mt-3 cursor-pointer'>FAQ</p>
                    <p className='mt-3 cursor-pointer'>Returns & Exchanges</p>
                    <p className='mt-3 cursor-pointer'>Shipping Policy</p>
                    <p className='mt-3 cursor-pointer'>Terms of Service</p>
                    <p className='mt-3 cursor-pointer'>Privacy Policy</p>
                    <p className='mt-3 cursor-pointer'>Careers</p>
                </div>
            </div>
    )
}

export default SectionOne
